import { createAction } from '@ngrx/store';

export const isLoading = createAction('[UI COMPONENT IS LOADING]');

export const stopLoading = createAction('[UI COMPONENT STOP LOADING]');
